<div class="modal-header">
    <h3 class="modal-title mb-0">Statement</h3>
</div>
<div class="modal-body">
    <form #form="ngForm" class="d-flex flex-row align-items-end mb-3 gap-2" novalidate (ngSubmit)="form.valid && init()">
        <div>
            <label for="date" class="form-label">Date From</label>
            <input type="date" class="form-control" id="date" name="date" #date="ngModel" [(ngModel)]="data.date_from">
        </div>
        <div>
            <label for="date" class="form-label">Date To</label>
            <input type="date" class="form-control" id="date" name="date" #date="ngModel" [(ngModel)]="data.date_to">
        </div>
        <button class="btn btn-primary" type="submit">Submit</button>
    </form>
    <table class="table table-bordered table-striped table-sm">
        <thead class="table-primary">
            <tr>
                <th>Date</th>
                <th class="text-end">Debit</th>
                <th class="text-end">Credit</th>
                <th class="text-end">Balance</th>
                <th>Remark</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let statement of statements">
                <td class="align-middle">{{statement.create_on | date:'dd/MM/yyyy HH:mm'}}</td>
                <td class="align-middle text-end">{{statement.debit | number:'1.2-2'}}</td>
                <td class="align-middle text-end">{{statement.credit | number:'1.2-2'}}</td>
                <td class="align-middle text-end">{{statement.balance | number:'1.2-2'}}</td>
                <td class="align-middle">{{statement.remark}}</td>
            </tr>
            <tr *ngIf="statements.length == 0"><td colspan="5" class="text-center">No data found</td></tr>
        </tbody>
        <tfoot *ngIf="statements.length > 0">
            <tr>
                <td class="text-start fw-bold">Total</td>
                <td class="text-end">{{sum('debit') | number:'1.2-2'}}</td>
                <td class="text-end">{{sum('credit') | number:'1.2-2'}}</td>
                <td class="text-end">{{sum('balance') | number:'1.2-2'}}</td>
                <td></td>
            </tr>
        </tfoot>
    </table>
</div>